import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-1e858bee"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "homebox clearfix"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "banner-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  height: "520",
  src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202410/ca493a37a8714a018f1f622693091f91.png"
})], -1));

const _hoisted_3 = {
  style: {
    "background": "#FAFBFC"
  },
  ref: "owinBox"
};
const _hoisted_4 = {
  class: "owin-height",
  ref: "owinRef"
};
const _hoisted_5 = {
  class: "teacher-wrapper",
  ref: "pride_tab_fixed"
};
const _hoisted_6 = {
  class: "category-list"
};

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  width: "18",
  src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202411/a8237bf7f3654b4a8153fedc27905345.png",
  alt: ""
}, null, -1));

const _hoisted_8 = /*#__PURE__*/_createTextVNode("荣誉称号 ");

const _hoisted_9 = {
  class: "category-title"
};
const _hoisted_10 = {
  class: "count"
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  width: "18",
  src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202410/5e5631c1296840d9ab9bac2e65946ec7.png",
  alt: ""
}, null, -1));

const _hoisted_12 = /*#__PURE__*/_createTextVNode("归属学院 ");

const _hoisted_13 = {
  class: "category-title"
};
const _hoisted_14 = {
  class: "count"
};
const _hoisted_15 = {
  key: 1,
  class: "teacher-box"
};
const _hoisted_16 = {
  class: "teacher-top"
};
const _hoisted_17 = {
  class: "teacher-main-title"
};
const _hoisted_18 = {
  class: "show-type"
};

const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-suolvetu"
}, null, -1));

const _hoisted_20 = [_hoisted_19];

const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-daohangguanli"
}, null, -1));

const _hoisted_22 = [_hoisted_21];
const _hoisted_23 = {
  key: 0,
  class: "teacher-list"
};
const _hoisted_24 = {
  key: 1,
  class: "empty-box"
};
const _hoisted_25 = {
  key: 2,
  class: "teacher-box"
};
const _hoisted_26 = {
  class: "teacher-top"
};
const _hoisted_27 = {
  class: "teacher-main-title"
};
const _hoisted_28 = {
  class: "show-type"
};

const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-suolvetu"
}, null, -1));

const _hoisted_30 = [_hoisted_29];

const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-daohangguanli"
}, null, -1));

const _hoisted_32 = [_hoisted_31];
const _hoisted_33 = {
  key: 0,
  class: "teacher-list2"
};
const _hoisted_34 = ["onClick"];

const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dot"
}, null, -1));

const _hoisted_36 = {
  class: "teacher-name text-overflow"
};
const _hoisted_37 = {
  key: 1,
  class: "empty-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Head = _resolveComponent("Head");

  const _component_el_menu_item = _resolveComponent("el-menu-item");

  const _component_el_sub_menu = _resolveComponent("el-sub-menu");

  const _component_el_menu = _resolveComponent("el-menu");

  const _component_el_affix = _resolveComponent("el-affix");

  const _component_el_input = _resolveComponent("el-input");

  const _component_TeacherCard = _resolveComponent("TeacherCard");

  const _component_Empty = _resolveComponent("Empty");

  const _component_el_pagination = _resolveComponent("el-pagination");

  const _component_Footer = _resolveComponent("Footer");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Head, {
    onUserRole: $options.getZhsRole,
    menuInfo: $data.menuInfo,
    "onUpdate:menuInfo": _cache[0] || (_cache[0] = $event => $data.menuInfo = $event),
    menuCode: '10501'
  }, null, 8, ["onUserRole", "menuInfo"]), _hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [$data.organ_flag.indexOf('1') > -1 || $data.organ_flag.indexOf('2') > -1 ? (_openBlock(), _createBlock(_component_el_affix, {
    key: 0,
    offset: 0,
    style: _normalizeStyle({
      'left': $data.titleFixed == true && $data.pageInfo.rows > 8 ? $options.computedValue + 'px' : '',
      'bottom': $data.pageInfo.rows > 12 && $data.menuRelative && $data.titleFixed ? '114px' : '0'
    }),
    class: _normalizeClass({
      isFixed: $data.titleFixed == true && $data.pageInfo.rows > 8 && !$data.menuRelative,
      isRelative: $data.pageInfo.rows > 8 && $data.menuRelative && $data.titleFixed
    })
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [$data.organ_flag.indexOf('1') > -1 ? (_openBlock(), _createBlock(_component_el_menu, {
      key: 0,
      "default-active": $data.searchInfo.titleId,
      "default-openeds": ['1']
    }, {
      default: _withCtx(() => [_createVNode(_component_el_sub_menu, {
        index: "1"
      }, {
        title: _withCtx(() => [_hoisted_7, _hoisted_8]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.teacherTitleList, (item, index) => {
          return _withDirectives((_openBlock(), _createBlock(_component_el_menu_item, {
            class: _normalizeClass(["category-item", $data.searchInfo.titleId == item.honorary_title_id ? 'active-tag' : '']),
            index: item.honorary_title_id + '',
            key: item.honorary_title_id,
            onClick: $event => $options.teacherTitleChange(item)
          }, {
            default: _withCtx(() => [_createElementVNode("span", _hoisted_9, _toDisplayString(item.honorary_title_name), 1), _createElementVNode("span", _hoisted_10, "(" + _toDisplayString(item.count) + ")", 1)]),
            _: 2
          }, 1032, ["class", "index", "onClick"])), [[_vShow, $data.showMoreTeacherTitle || index < 6]]);
        }), 128)), $data.teacherTitleList.length > 6 ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "category-btn",
          onClick: _cache[1] || (_cache[1] = (...args) => $options.toggleShowTeacherTitle && $options.toggleShowTeacherTitle(...args))
        }, _toDisplayString($data.showMoreTeacherTitle ? "-" : "+"), 1)) : _createCommentVNode("", true)]),
        _: 1
      })]),
      _: 1
    }, 8, ["default-active"])) : _createCommentVNode("", true), $data.organ_flag.indexOf('2') > -1 ? (_openBlock(), _createBlock(_component_el_menu, {
      key: 1,
      "default-active": $data.searchInfo.collegeId,
      "default-openeds": ['2']
    }, {
      default: _withCtx(() => [_createVNode(_component_el_sub_menu, {
        index: "2"
      }, {
        title: _withCtx(() => [_hoisted_11, _hoisted_12]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.collegeList, ({
          organ_name,
          organ_id,
          count = 0
        }, index) => {
          return _withDirectives((_openBlock(), _createBlock(_component_el_menu_item, {
            class: _normalizeClass(["category-item", $data.searchInfo.collegeId == organ_id ? 'active-tag' : '']),
            index: organ_id + '',
            key: index,
            onClick: $event => $options.collegeChange(organ_id, organ_name)
          }, {
            default: _withCtx(() => [_createElementVNode("span", _hoisted_13, _toDisplayString(organ_name), 1), _createElementVNode("span", _hoisted_14, "(" + _toDisplayString(count) + ")", 1)]),
            _: 2
          }, 1032, ["class", "index", "onClick"])), [[_vShow, $data.showMoreCollege || index < 6]]);
        }), 128)), $data.collegeList.length > 6 ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "category-btn",
          onClick: _cache[2] || (_cache[2] = (...args) => $options.toggleShowCollege && $options.toggleShowCollege(...args))
        }, _toDisplayString($data.showMoreCollege ? "-" : "+"), 1)) : _createCommentVNode("", true)]),
        _: 1
      })]),
      _: 1
    }, 8, ["default-active"])) : _createCommentVNode("", true)])]),
    _: 1
  }, 8, ["style", "class"])) : _createCommentVNode("", true), $data.showType == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("span", {
    class: _normalizeClass(["suoluotu", $data.showType == 1 ? 'active' : '']),
    onClick: _cache[3] || (_cache[3] = (...args) => $options.showType1 && $options.showType1(...args))
  }, _hoisted_20, 2), _createElementVNode("span", {
    class: _normalizeClass($data.showType == 2 ? 'active' : ''),
    onClick: _cache[4] || (_cache[4] = (...args) => $options.showType2 && $options.showType2(...args))
  }, _hoisted_22, 2)])]), _createVNode(_component_el_input, {
    modelValue: $data.teacherName,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.teacherName = $event),
    size: "default",
    class: "search-input",
    onKeyup: _withKeys($options.handleSearch, ["enter"]),
    placeholder: "搜索教师名称"
  }, {
    prefix: _withCtx(() => [_createElementVNode("i", {
      class: "iconfont icon-sousuo search-icon",
      onClick: _cache[5] || (_cache[5] = (...args) => $options.handleSearch && $options.handleSearch(...args))
    })]),
    _: 1
  }, 8, ["modelValue", "onKeyup"])]), $data.teacherList && $data.teacherList.length ? (_openBlock(), _createElementBlock("div", _hoisted_23, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.teacherList, teacher => {
    return _openBlock(), _createBlock(_component_TeacherCard, {
      "teacher-data": teacher,
      key: teacher.id
    }, null, 8, ["teacher-data"]);
  }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_24, [_createVNode(_component_Empty, {
    text: "暂无数据"
  })])), $data.pageInfo.rows && $data.pageInfo.rows > $data.pageInfo.pageLimit ? (_openBlock(), _createBlock(_component_el_pagination, {
    key: 2,
    class: "teacher-pagination",
    background: "",
    layout: "prev, pager, next",
    "prev-text": "上一页",
    "next-text": "下一页",
    onCurrentChange: $options.pageIndexChange,
    "current-page": $data.pageInfo.pageIndex,
    total: $data.pageInfo.rows,
    "page-size": $data.pageInfo.pageLimit
  }, null, 8, ["onCurrentChange", "current-page", "total", "page-size"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $data.showType == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createElementVNode("span", {
    class: _normalizeClass(["suoluotu", $data.showType == 1 ? 'active' : '']),
    onClick: _cache[7] || (_cache[7] = (...args) => $options.showType1 && $options.showType1(...args))
  }, _hoisted_30, 2), _createElementVNode("span", {
    class: _normalizeClass($data.showType == 2 ? 'active' : ''),
    onClick: _cache[8] || (_cache[8] = (...args) => $options.showType2 && $options.showType2(...args))
  }, _hoisted_32, 2)])]), _createVNode(_component_el_input, {
    modelValue: $data.teacherName,
    "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.teacherName = $event),
    size: "default",
    class: "search-input",
    onKeyup: _withKeys($options.handleSearch, ["enter"]),
    placeholder: "搜索教师名称"
  }, {
    prefix: _withCtx(() => [_createElementVNode("i", {
      class: "iconfont icon-sousuo search-icon",
      onClick: _cache[9] || (_cache[9] = (...args) => $options.handleSearch && $options.handleSearch(...args))
    })]),
    _: 1
  }, 8, ["modelValue", "onKeyup"])]), $data.teacherList && $data.teacherList.length ? (_openBlock(), _createElementBlock("div", _hoisted_33, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.teacherList, item => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["teacher-card-list", $data.organ_flag.indexOf('1') == -1 && $data.organ_flag.indexOf('2') == -1 ? '' : 'teacher-card-list2']),
      key: item.id,
      onClick: $event => $options.goDetail(item.id)
    }, [_hoisted_35, _createElementVNode("span", _hoisted_36, _toDisplayString(item.teacher_name), 1)], 10, _hoisted_34);
  }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_37, [_createVNode(_component_Empty, {
    text: "暂无数据"
  })])), $data.pageInfo.rows && $data.pageInfo.rows > $data.pageInfo.pageLimit2 ? (_openBlock(), _createBlock(_component_el_pagination, {
    key: 2,
    class: "teacher-pagination",
    background: "",
    layout: "prev, pager, next",
    "prev-text": "上一页",
    "next-text": "下一页",
    onCurrentChange: $options.pageIndexChange,
    "current-page": $data.pageInfo.pageIndex,
    total: $data.pageInfo.rows,
    "page-size": $data.pageInfo.pageLimit2
  }, null, 8, ["onCurrentChange", "current-page", "total", "page-size"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 512)], 512)], 512), _createVNode(_component_Footer)]);
}